import React, { useContext } from 'react';
import QGetAllFrames from '../../_graphql/queries/documents/QGetAllFrames';
import { UserContext } from '../../withUser';
import { getOfferIdsByUserTeam } from '../helpers/getOfferIdsByUserTeam';
import FrameForm from './components/FrameForm';

const CreateFrame = () => {
  const { userTeam } = useContext(UserContext);
  const offerIds = getOfferIdsByUserTeam(userTeam, true);

  return (
    <QGetAllFrames args={{ offerIds }}>
      {({ allFrames }) => <FrameForm allFrames={allFrames} offerIds={offerIds} />}
    </QGetAllFrames>
  );
};

export default CreateFrame;
